<template>
    <div class="control-panel-extra" v-if="show">
        <div class="control-panel-extra-header">
            <h1>
                <slot name="title"></slot>
            </h1>
            <button type="button" @click="$emit('close')">x</button>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true,
            default: false,
        },
        title: {
            type: String,
        },
    },
};
</script>

<style lang="scss">
.control-panel-extra {
    width: 300px;
    background-color: #fff;
    border-left: 1px solid #6e7c7c;
    transition: all 0.5s ease-in-out;
    display: flex;
    flex-direction: column;
    .control-panel-extra-header {
        display: flex;
        flex-wrap: nowrap;
        line-height: 40px;
        align-items: center;
        h1 {
            font-size: 1em;
            line-height: 40px;
            flex-grow: 2;
            padding-left: 15px;
            //border-bottom: 1px solid #6e7c7c;
            margin: 0;
        }
        button {
            width: 40px;
            font-size: 20px;
            flex-grow: 0;
            background-color: #6e7c7c;
            color: #fff;
            border: none;
        }
    }
}
.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s ease-in-out;
}

.slide-enter,
.slide-leave-to {
    width: 0px !important;
}
</style>
